import { call, put, select } from 'redux-saga/effects';

import { selectors as sessionSelectors } from 'store/session';

import * as actions from './actions';
import service from './service';

export default function* root() {}

export function* fetchProcesses() {
  const groupId = yield select(sessionSelectors.getGroupId);
  const response = yield call(service.listProcesses, groupId);
  yield put(actions.fetchProcesses(response));
  return response;
}
